<template>
  <v-dialog max-width="540" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>{{ $t("page.reservation.concept-pattern-detail") }}</span>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="concept-card-text">
        <div v-if="hasPatternImages" class="pattern-images-grid">
          <!-- 기본 패턴 이미지 (pattern_1_image) -->
          <div v-if="concept.pattern_1_image" class="pattern-image-item">
            <div class="pattern-badge">A</div>
            <v-img :src="'/upload/concept/thumbnail_image/' + concept.pattern_1_image" :lazy-src="require('@/assets/placeholder.jpg')" aspect-ratio="0.83" class="rounded-lg">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <!-- 추가 패턴 이미지들 (pattern_others_image) -->
          <div v-for="(pattern, index) in sortedPatternOthers" :key="pattern.id" class="pattern-image-item">
            <div class="pattern-badge">{{ getPatternLabel(index + 1) }}</div>
            <v-img :src="'/upload/concept/thumbnail_image/' + pattern.image" :lazy-src="require('@/assets/placeholder.jpg')" aspect-ratio="0.83" class="rounded-lg">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </div>
        <div v-else class="text-center py-8">
          <span class="grey--text text-body-1">{{ $t("page.reservation.no-pattern-images") }}</span>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center pb-4">
        <v-btn color="#EF7FAB" class="dialog_btn rounded-2" style="font-size: 18px" width="40%" depressed @click="$emit('close')" large>
          {{ $t("button.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "ConceptPatternDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    concept: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["lang"]),

    hasPatternImages() {
      return this.concept && (this.concept.pattern_1_image || this.patternOthers.length > 0)
    },

    patternOthers() {
      if (!this.concept || !this.concept.pattern_others_image) {
        return []
      }

      try {
        const parsed = typeof this.concept.pattern_others_image === "string" ? JSON.parse(this.concept.pattern_others_image) : this.concept.pattern_others_image

        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        console.error("Failed to parse pattern_others_image:", e)
        return []
      }
    },

    sortedPatternOthers() {
      return [...this.patternOthers].sort((a, b) => (a.order || 0) - (b.order || 0))
    },
  },
  methods: {
    getPatternLabel(index) {
      // A=65, B=66, C=67...
      return String.fromCharCode(65 + index)
    },
  },
}
</script>

<style scoped>
::v-deep .v-card {
  border: 3px solid #dadada !important;
  border-radius: 8px;
}

.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
}

.pattern-images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 8px 0;
}

.concept-card-text {
  padding: 0px 8px !important;
}

.pattern-image-item {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.pattern-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: #ef7fab;
  color: white;
  font-size: 18px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 2px solid white;
}

.rounded-lg {
  border-radius: 8px;
  border: 2px solid #f5e4e4;
}
</style>
